import { routes } from "@/constants/routes";
import { Redirect } from "expo-router";

export default function TenantAnimalNewRedirect() {
  return <Redirect href={routes.myAnimals} />;
}
